import { Config } from '../config/env/companies'

// @ts-expect-error window.__BD_CONFIG is set by an external script
const casted = window.__BD_CONFIG
// eslint-disable-next-line
export const config: Config = casted
